"use strict";
module.exports = {
    APPOINTMENT_STATUS: {
        PREVIOUS: 'previous',
        PENDING: 'pending_appointment',
        CURRENT: 'current',
    },
};
